import React from "react";

interface HeaderProps {
  title?: string;
  subheader?: string;
  className?: string;
  align?: "left" | "center";
}

const Header: React.FC<HeaderProps> = ({
  title,
  subheader,
  className,
  align,
}) => {
  if (!title) return null;

  const alignment =
    align === "left" ? "items-start text-left" : "items-center text-center";

  return (
    <div
      className={`flex flex-col gap-1.5 ${alignment} mb-4 mt-3 w-full ${className}`}
    >
      <h1 className="text-xl font-medium text-pluto-night dark:text-text-primary-dark">
        {title}
      </h1>
      {subheader && (
        <p className="text-pluto-progress  text-sm dark:text-text-secondary-dark">
          {subheader}
        </p>
      )}
    </div>
  );
};

export default Header;
